// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-not-found {\n  text-align: center;\n  margin-top: 124px;\n  font-weight: 500;\n  color: #888888;\n}", ""]);
// Exports
module.exports = exports;
